<div class="header-bottom">
   <div class="container">
      <div class="flspacebetween row">
         <div class="brand-name flmid tmain-one col-auto">
            <div [ngClass]="licensePlateClass" class="licence-pl small">
               <input type="text" value="{{vehicleDetail?.licensePlateNumber}}" readonly />
            </div>
            <div class="brand-logo-bg">
               <app-brand-image></app-brand-image>
            </div>
         </div>
         <div class="brand-name flmid tmain-two col-auto">
            <span style="margin-right: 10px;">{{vehicleDetail?.companyModel}}</span>
            <div class="seperator"></div>
            <span style="margin-left: 10px;" class="name">{{customerDetail?.customerName}}</span>
         </div>
      </div>
   </div>
</div>